import api from 'utils/api'

export const getStatesGeometry = (states) => {
  return api.get(`/geo/json/states?states=${states.join(',')}`)
}
